import { jsx as t, jsxs as n } from "react/jsx-runtime";
import { useCallback as u } from "react";
import "styled-components";
import { useThemeInMode as x } from "../../../context/theme/hooks.js";
import { DISABLED_OPACITY as d } from "../../../styles/colors/consts.js";
import "../../layout/Stack/Stack.js";
import p from "../../layout/Box/Box.js";
import "../../../index-CZ8zjHGv.js";
import "../../layout/Center/Center.js";
import m from "../../layout/Column/Column.js";
import _ from "../../layout/Columns/Columns.js";
import "../../layout/Columns/ColumnsContext.js";
import "../../../context/WindowSize/Dimensions.js";
import "lodash-es";
const b = "_input_1xgc5_1", v = "_svg_1xgc5_1", y = "_label_1xgc5_14", s = {
  input: b,
  svg: v,
  label: y
};
function X({
  name: e,
  checked: o = !1,
  partiallyChecked: c = !1,
  onChange: h,
  children: a,
  disabled: i = !1
}) {
  const r = x(), l = o ? r["primary-high-content"] : r["neutral-high-content"], f = u((g) => {
    g.stopPropagation();
  }, []);
  return /* @__PURE__ */ t(
    p,
    {
      position: "relative",
      component: "label",
      htmlFor: e,
      display: "flex",
      alignItems: "center",
      onClick: f,
      opacity: i ? d : "1",
      cursor: i ? "not-allowed" : "pointer",
      className: s.label,
      children: /* @__PURE__ */ n(_, { space: "large", alignY: "center", children: [
        /* @__PURE__ */ n(m, { alignX: "flex-start", width: "content", children: [
          /* @__PURE__ */ t(
            p,
            {
              component: "input",
              type: "checkbox",
              onChange: h,
              disabled: i,
              checked: o,
              name: e,
              id: e,
              position: "absolute",
              left: "-10000px",
              top: "auto",
              width: "1px",
              height: "1px",
              opacity: "0.0001",
              className: s.input
            }
          ),
          /* @__PURE__ */ n(
            "svg",
            {
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
              fill: r.foreground,
              "aria-hidden": "true",
              focusable: "false",
              className: s.svg,
              children: [
                /* @__PURE__ */ t(
                  "rect",
                  {
                    x: "0.5",
                    y: "0.5",
                    width: "23",
                    height: "23",
                    rx: "1.5",
                    stroke: l
                  }
                ),
                o && /* @__PURE__ */ t(
                  "path",
                  {
                    d: "M5 12.1852L9.30769 16.3333L19 7",
                    stroke: l,
                    strokeWidth: "1.4"
                  }
                ),
                c && !o && /* @__PURE__ */ t("path", { d: "M4 12.5H19", stroke: l, strokeWidth: "1.4" })
              ]
            }
          )
        ] }),
        a && /* @__PURE__ */ t(m, { alignX: "flex-start", children: a })
      ] })
    }
  );
}
export {
  X as default
};
